import React, {useEffect, useState} from "react";
import Card from "../../components/Base/Card";
import {FiArrowLeft} from "react-icons/fi";
import SuccessModal from "../../components/SuccessModal";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorViewer from "../../components/ErrorViewer";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {
    EmployerConfirmation,
    getAllEmployer,
    GetDepartment,
    PDO,
} from "../../redux/selfService/selfServiceSlice";
import {EmployerinformationI} from "../../interfaces";
import LoadingSpinner from "../../components/LoadingSpinner";
import Required from "../../components/Required";

interface PropsI {
    onClose : ()=>void;
}

const ConfirmEmployer = ({ onClose }: PropsI) => {
    const dispatch = useAppDispatch();
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const { allEmployer, departments, isLoading } = useAppSelector((state) => state?.selfService);
    const { user } = useAppSelector((state) => state?.auth);

    useEffect(()=>{
        dispatch(GetDepartment())
    }, [])

    useEffect(()=>{
        if(user.employerId) {
            dispatch(getAllEmployer(user.employerId))
        }
    }, [user])

    const validationSchema = Yup.object().shape({
        surname: Yup.string().required("Surname is required"),
        firstname: Yup.string().required("Firstname is required"),
        othernames: Yup.string(),
        employerId: Yup.string().required("Employer ID is required"),
        designation: Yup.string().required("Designation is required"),
        departmentId: Yup.string().required("Department is required"),
        email: Yup.string().required("Email is required"),
        phone: Yup.string().required("Phone Number is required"),
    });

    const defaultValues = {
        surname: '',
        firstname: '',
        othernames: '',
        employerId: '0',
        designation: '',
        departmentId: '0',
        email: '',
        phone: '',
    }

    const { handleSubmit, register, reset, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues
    });

    const onSubmit = async (values: any) => {
        const createPDOAction = await dispatch(PDO({
            ...values,
            departmentId: parseInt(values.departmentId, 10),
            employerId: parseInt(values.employerId, 10)
        }));
        if(createPDOAction?.type === 'selfService/PDO/fulfilled'){
            reset(defaultValues)
            setShowSuccessModal(true)
            dispatch(EmployerConfirmation());
        }
    }

    return (
        <div className="settings-page">
            <SuccessModal
                showModal={showSuccessModal}
                onClose={()=>{
                    setShowSuccessModal(false)
                    onClose()
                }}
                note={"Pension desk officer information successfully submitted."}
            />
            <div className="mx-4">
                <div className="flex text-primary my-10">
                    <button className="btn btn-outline font-semibold mr-4" onClick={onClose}>
                        <FiArrowLeft className="mr-1 text-xl"/>
                        Back
                    </button>
                </div>


                <div className="h1 text-grayscaleBody">
                    Confirm Employer
                </div>
                <div className="w-full">
                    <Card className="mb-8 bg-grayscaleBG">
                        <div className="section-card">
                            <div className="pt-12">
                                PDO Information
                            </div>
                            <div className="w-full">
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="firstName" className="form__label">
                                            First Name: <Required />
                                        </label>
                                        <input id="firstName" placeholder="First Name" type="text" className="form__input" {...register("firstname")} />
                                        {errors.firstname && (
                                            <ErrorViewer message={errors.firstname.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="lastname" className="form__label">Surname: <Required /></label>
                                        <input placeholder="Last Name" type="text" id="lastname"
                                               className="form__input" {...register("surname")} />
                                        {errors.surname && (
                                            <ErrorViewer message={errors.surname.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="othernames" className="form__label">
                                            Other Name:
                                        </label>
                                        <input placeholder="Other Names" type="text" id="othernames"
                                               className="form__input" {...register("othernames")} />
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="title" className="form__label">
                                            Employer <Required />
                                        </label>
                                        <select id="title" className="form__select" {...register("employerId")} >
                                            <option value="">Select Employer</option>
                                            {
                                                allEmployer && allEmployer.length > 0 && allEmployer.map((employer: EmployerinformationI) =>
                                                    <option value={employer.id} key={employer.id}>{employer.txtemployername}</option>
                                                )
                                            }
                                        </select>
                                        {errors.surname && (
                                            <ErrorViewer message={errors.surname.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="gender" className="form__label">Department: <Required /></label>
                                        <select id="gender" className="form__select" {...register("departmentId")} >
                                            <option value="">Select a Department</option>
                                            {
                                                departments.length > 0 && departments.map((department)=>(
                                                    <option value={department.id} key={department.id}>{department.departmentType}</option>
                                                ))
                                            }
                                        </select>
                                        {errors.departmentId && (
                                            <ErrorViewer message={errors.departmentId.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="designation" className="form__label">
                                            Designation <Required />
                                        </label>
                                        <input placeholder="Designation" type="text" id="designation"
                                               className="form__input" {...register("designation")} />
                                        {errors.designation && (
                                            <ErrorViewer message={errors.designation.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="email" className="form__label">
                                            Email Address: <Required />
                                        </label>
                                        <input placeholder="Email Address" type="email" id="email"
                                               className="form__input" {...register("email")} />
                                        {errors.email && (
                                            <ErrorViewer message={errors.email.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="phone-number" className="form__label">
                                            Phone Number: <Required />
                                        </label>
                                        <input placeholder="Phone Number" type="text" id="phone-number"
                                               className="form__input" {...register("phone")} />
                                        {errors.phone && (
                                            <ErrorViewer message={errors.phone.message as string}/>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                    <div className="flex justify-end text-primary mb-40">
                        <button
                            className="btn btn-primary font-semibold mr-4"
                            onClick={handleSubmit(onSubmit)}
                            disabled={isLoading}
                        >
                            {
                                isLoading ? <LoadingSpinner /> : "Create PDO"
                            }
                        </button>
                    </div>
                </div>

            </div>

        </div>
    );
}
export default ConfirmEmployer;